import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IconModule } from '../icon';
import { EmptyContentComponent } from './empty-content.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    IconModule
  ],
  declarations: [
    EmptyContentComponent
  ],
  exports: [
    EmptyContentComponent
  ]
})
export class EmptyContentModule {
}
